// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611041633/js/" + chunkId + "." + {"44":"bbc40150","225":"7537ae65","481":"6ad63d7a","486":"17a3143c","770":"38277be4"}[chunkId] + ".0.943587222059594.chunk.js";
};